import React, { useEffect, useState, useRef } from 'react';

const CookieHeroSection = () => {
    const [activeTab, setActiveTab] = useState('support-tab-1');
    const sectionRefs = useRef({});

    const sections = [
        { id: 'support-tab-1', title: 'What are cookies?' },
        { id: 'support-tab-2', title: 'Why do we use cookies?' },
        { id: 'support-tab-3', title: 'How can you control cookies?' },
        { id: 'support-tab-4', title: 'Essential website cookies' },
        { id: 'support-tab-5', title: 'Analytics and customization cookies ' },
        { id: 'support-tab-6', title: 'How can you control cookies on your browser?' },
        { id: 'support-tab-7', title: 'What about other tracking technologies, like web beacons?' },
        { id: 'support-tab-8', title: 'Do you use flash cookies or local shared objects?' },
        { id: 'support-tab-9', title: 'Do we serve targeted advertising?' },
        { id: 'support-tab-10', title: 'How often will we update the cookie policy?' },
        { id: 'support-tab-11', title: 'Where can you get further information?' },
    ];

    // Observe sections on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveTab(entry.target.id);
                    }
                });
            },
            { threshold: 0.5 }
        );

        sections.forEach((section) => {
            if (sectionRefs.current[section.id]) {
                observer.observe(sectionRefs.current[section.id]);
            }
        });

        return () => {
            sections.forEach((section) => {
                if (sectionRefs.current[section.id]) {
                    observer.unobserve(sectionRefs.current[section.id]);
                }
            });
        };
    }, []);

    // Smooth scroll on click
    const handleClick = (id) => {
        const element = sectionRefs.current[id];
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="support-content pb-60">
            <div className="container">
                <div className="row justify-content-between">
                    {/* Sidebar */}
                    <div className="col-lg-4 col-md-4 d-none d-md-block d-lg-block">
                        <div className="support-article-sidebar sticky-sidebar">
                            <div className="nav flex-column nav-pills support-article-tab bg-light rounded-custom p-4">
                                {sections.map((section) => (
                                    <button
                                        key={section.id}
                                        className={`nav-link text-start fw-bold ${activeTab === section.id ? 'active' : ''
                                            }`}
                                        onClick={() => handleClick(section.id)}
                                    >
                                        {section.title}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-lg-7 col-md-8">
                        <div>
                            {/* Section 1 */}
                            <div
                                id="support-tab-1"
                                ref={(el) => (sectionRefs.current['support-tab-1'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>What are cookies ?</h4>
                                <p>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.</p>
                                <p>
                                    Cookies set by the website owner (in this case, Senertech) are called “first-party cookies”. Cookies set by parties other than the website owner are called "third-party cookies." Third-party cookies enable third-party features or functionality to be provided on or through the website (e.g., advertising, interactive content, and analytics). The parties that set these third-party cookies can recognise your computer both when it visits the website in question and also when it visits certain other websites.
                                </p>
                            </div>

                            {/* Section 2 */}
                            <div
                                id="support-tab-2"
                                ref={(el) => (sectionRefs.current['support-tab-2'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>Why do we use cookies ?</h4>
                                <p>We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our website to operate, and we refer to these as “essential” or “strictly necessary” cookies. Other cookies also enable us to track and target the interests of our users to enhance the experience on our online properties. Third parties serve cookies through our website for advertising, analytics, and other purposes. This is described in more detail below.</p>

                            </div>

                            {/* Section 3 */}
                            <div
                                id="support-tab-3"
                                ref={(el) => (sectionRefs.current['support-tab-3'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>How can you control cookies ?</h4>
                                <p>
                                    You have the right to decide whether to accept or reject cookies. You can exercise your cookie rights by setting your preferences in the cookie consent manager. The cookie consent manager allows you to select which categories of cookies you accept or reject. Essential cookies cannot be rejected as they are strictly necessary to provide you with services.
                                </p><p>
                                    The cookie consent manager can be found in the notification banner and on our website. If you choose to reject cookies, you may still use our website, though your access to some functionality and areas of our website may be restricted. You may also set or amend your web browser controls to accept or refuse cookies.
                                </p><p>
                                    The specific types of first-party and third-party cookies served through our website and the purposes they perform are described in the table below (please note that the specific cookies served may vary depending on the specific online properties you visit.
                                </p>

                            </div>

                            {/* Section 4 */}
                            <div
                                id="support-tab-4"
                                ref={(el) => (sectionRefs.current['support-tab-4'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>Essential website cookies</h4>
                                <p>
                                    These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as access to secure areas.</p>


                                <table style={{ borderCollapse: "collapse", width: "70%" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Name</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>rc::a</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Purpose</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                Used to track and analyse user behaviour to distinguish humans from
                                                bots or automated software.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Provider</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                www.google.com
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Service</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>reCAPTCHA</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Type</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                html_local_storage
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Expires in</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                persistent
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>


                            </div>


                            {/* Section 5 */}
                            <div
                                id="support-tab-5"
                                ref={(el) => (sectionRefs.current['support-tab-5'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Analytics and customization cookies
                                </h4>
                                <p>These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are, or to help us customise our website for you.</p>
                                <table style={{ borderCollapse: "collapse", width: "70%" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Name</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>s7</td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Purpose</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                Gather data regarding site usage and user behaviour on the website.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Provider</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                wms.senertech.in
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Service</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                Adobe Analytics
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Type</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                html_local_storage
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                <strong>Expires in</strong>
                                            </td>
                                            <td style={{ border: "1px solid #000", padding: "8px" }}>
                                                persistent
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                            {/* Section 6 */}
                            <div
                                id="support-tab-6"
                                ref={(el) => (sectionRefs.current['support-tab-6'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    How can you control cookies on your browser ?
                                </h4>
                                <p>As the means by which you can refuse cookies through your web browser controls vary from browser to browser, you should visit your browser's help menu for more information. In addition, most advertising networks offer you a way to opt out of targeted advertising.</p>
                            </div>


                            {/* Section 7 */}
                            <div
                                id="support-tab-7"
                                ref={(el) => (sectionRefs.current['support-tab-7'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    What about other tracking technologies, like web beacons ?
                                </h4>
                                <p>Cookies are not the only way to recognise or track visitors to a website. We may use other, similar technologies from time to time, like web beacons (sometimes called "tracking pixels" or "clear gifs"). These are tiny graphics files that contain a unique identifier that enables us to recognise when someone has visited our website or opened an email including them. This allows us, for example, to monitor the traffic patterns of users from one page within a website to another, to deliver or communicate with cookies, to understand whether you have come to the website from an online advertisement displayed on a third-party website, to improve site performance, and to measure the success of email marketing campaigns. In many instances, these technologies are reliant on cookies to function properly, and so declining cookies will impair their functioning.
                                </p>
                            </div>


                            {/* Section 8 */}
                            <div
                                id="support-tab-8"
                                ref={(el) => (sectionRefs.current['support-tab-8'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Do you use flash cookies or local shared objects ?
                                </h4>
                                <p>
                                    Websites may also use so-called "flash cookies" (also known as local shared objects or "LSOs") to, among other things, collect and store information about your use of our services, fraud prevention, and for other site operations.
                                </p>
                                <p>If you do not want Flash cookies stored on your computer, you can adjust the settings of your Flash player to block Flash cookies storage using the tools contained in the website storage settings panel (https://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html). You can also control flash cookies by going to the global storage settings panel (https://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager03.html) and following the instructions (which may include instructions that explain, for example, how to delete existing flash cookies (referred to "information" on the Macromedia site), how to prevent flash LSOs from being placed on your computer without your being asked, and how to block flash cookies that are not being delivered by the operator of the page you are on at the time.</p>
                                <p>Please note that setting the Flash player to restrict or limit acceptance of Flash cookies may reduce or impede the functionality of some Flash applications, including, potentially, Flash applications used in connection with our services or online content.
                                </p>



                            </div>


                            {/* Section 9 */}
                            <div
                                id="support-tab-9"
                                ref={(el) => (sectionRefs.current['support-tab-9'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4>
                                    Do we serve targeted advertising ?
                                </h4>
                                <p>Third parties may serve cookies on your computer or mobile device to serve advertising through our website. These companies may use information about your visits to this and other websites in order to provide relevant advertisements about goods and services that you may be interested in. They may also employ technology that is used to measure the effectiveness of advertisements. They can accomplish this by using cookies or web beacons to collect information about your visits to this and other sites in order to provide relevant advertisements about goods and services of potential interest to you. The information collected through this process does not enable us or them to identify your name, contact details, or other details that directly identify you unless you choose to provide these.
                                </p>
                            </div>


                            {/* Section 10 */}
                            <div
                                id="support-tab-10"
                                ref={(el) => (sectionRefs.current['support-tab-10'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    How often will we update the cookie policy ?
                                </h4>
                                <p>

                                    We may update this cookie policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please therefore revisit this cookie policy regularly to stay informed about our use of cookies and related technologies. The date at the bottom of this cookie policy indicates when it was last updated.


                                </p>

                            </div>


                            {/* Section 11 */}
                            <div
                                id="support-tab-11"
                                ref={(el) => (sectionRefs.current['support-tab-11'] = el)}
                                style={{ scrollMarginTop: '80px' }}
                                className="support-article-wrap mb-5"
                            >
                                <h4 className='mb-4'>
                                    Where can you get further information ?
                                </h4>
                                <p>
                                    If you have any questions about this cookie policy or other technologies, please contact us at hello@senertech.in.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CookieHeroSection;

